import type { EnquirySource, EnquiryStatus, EnquiryType } from '@cdf/api-client-react';

/** Shared display metadata for enquiry status/source/type across inbox + detail. */

export const enquiryStatusOrder: EnquiryStatus[] = [
  'new',
  'in_progress',
  'confirmed',
  'converted',
  'cancelled',
  'closed'
];

export const enquiryStatusLabels: Record<EnquiryStatus, string> = {
  new: 'New',
  in_progress: 'In progress',
  converted: 'Converted',
  closed: 'Closed',
  confirmed: 'Confirmed',
  cancelled: 'Cancelled'
};

/** Monochrome badge variants: "new" is the most prominent. */
export const enquiryStatusBadgeVariant: Record<
  EnquiryStatus,
  'default' | 'secondary' | 'outline'
> = {
  new: 'default',
  in_progress: 'secondary',
  converted: 'outline',
  closed: 'outline',
  confirmed: 'secondary',
  cancelled: 'outline'
};

export const enquirySourceOrder: EnquirySource[] = ['web_form', 'chat', 'email', 'manual', 'portal', 'social', 'voice'];

export const enquirySourceLabels: Record<EnquirySource, string> = {
  web_form: 'Web form',
  chat: 'Website chat',
  email: 'Mailbox email',
  manual: 'Manual',
  portal: 'Partner Portal',
  social: 'Social media',
  voice: 'Voice agent'
};

export const enquiryTypeOrder: EnquiryType[] = ['general', 'booking'];

export const enquiryTypeLabels: Record<EnquiryType, string> = {
  general: 'General',
  booking: 'Booking / meeting'
};

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}
